import { AddButton } from '@src/main/shared/ui/components/button/add/AddButton';
import HeaderTitle from '@src/main/shared/ui/components/header/HeaderTitle';
import { TabMenu, TabMenuTabChangeEvent } from 'primereact/tabmenu';
import { FC } from 'react';
import styles from './TabHeader.module.scss';

interface TabItem {
  label: string;
  icon: string;
}

interface TabHeaderProps {
  title: string;
  items: TabItem[];
  activeIndex: number;
  onTabChange: (e: TabMenuTabChangeEvent) => void;
  onNew?: () => void;
  buttonLabel?: string;
}

const TabHeader: FC<TabHeaderProps> = ({
  title,
  items,
  activeIndex,
  onTabChange,
  onNew,
  buttonLabel,
}) => (
  <div className={styles.header}>
    <HeaderTitle title={title} />
    <div className={styles['tabs-and-button-row']}>
      <div className={styles['tab-menu-container']}>
        <TabMenu model={items} activeIndex={activeIndex} onTabChange={onTabChange} />
      </div>
      {onNew && <AddButton label={buttonLabel ?? ''} onClick={onNew} />}
    </div>
  </div>
);

export default TabHeader;
